module.exports = __webpack_public_path__ + "static/sunkissed-regular-webfont-fcddded4bb53a2d0e065d3b762126898.ttf";